import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpc } from '../../services/service-jsonrpc'
import { AtylHttpClient } from '../../services/service-http'


@Injectable({
  providedIn: 'root'
})
export class AtylService {

  dossier: any = new BehaviorSubject('');

  constructor(
    private http: AtylHttpClient
  ) { }

  /*STATES*/
  updateDossier(dossier: any) {
    this.dossier.next(dossier)
  }
  /**/

  getForm(_typeForm: any, _dossierid?: string): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.formulaire:new',
      params: {
        type: _typeForm,
        options: {
        }
      }
    })
    if (_dossierid)
      rpcMethod.params.options.dossier = _dossierid

    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  getFormulaire(_id: string, parent?: any, instructionid?: any, tiersID?: any, parentFormID?: any): Observable<any> {

    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.formulaire:new',
      params: {
        idAForm: _id,
        options: {
          parent: parent,
          tiersId: tiersID,
          parentForm: parentFormID,
        }
      }

    })

    if (instructionid)
      rpcMethod.params.options.instruction = instructionid

    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  v3getFormulaire(_id: string, _options: any = []): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.formulaire:new',
      params: {
        idAForm: _id,
        options: _options
      }
    })
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  getFormulaireByID(formulaireID: any, formType?: any,dossier?: any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.formulaire:get',
      params: {
        id: formulaireID,
        options: {
          type: formType,
          childView: true,
		  dossier: dossier
        }
      }
    })
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  
  getFormulaireByIDOption(id: any, options: any = []): Observable<any> {
  		let rpcMethod = new JSONRpc({
  			jsonrpc: '2.0',
  			method: 'webservice.formulaire:get',
  			params: {
  				id: id,
  				options: options,
  			},
  		})
  		return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  
  setNewFormulaire(_type: string, _fields: any, idDemande: any, instructionid?: any, parentid?: any, etat?: any, favorable?: any, dossier?: any, parentForm?: any, intervention?: any,visite?: any
   ,demande_date_debut?:string,demande_date_fin?:string): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.formulaire:set',
      params: {
        type: _type,
        idDemande: idDemande,
        options: {
          fields: _fields,
          etat: etat ? Number(etat) : 0,
          favorable: favorable ? Number(favorable) : 0
        }
      }
    })
    if (instructionid)
      rpcMethod.params.options.instruction = instructionid
    if (parentid)
      rpcMethod.params.options.parent = parentid
    if (dossier)
      rpcMethod.params.options.dossier = dossier
    if (parentForm)
      rpcMethod.params.options.parentForm = parentForm
    if (intervention)
      rpcMethod.params.options.intervention = intervention
      
    if (visite)
      rpcMethod.params.options.visite = visite
   if (demande_date_debut)
      rpcMethod.params.options.demande_date_debut = demande_date_debut
      
    if (demande_date_fin)
      rpcMethod.params.options.demande_date_fin = demande_date_fin  
      
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  setFormulaire(form: any, instruction?: any, demandeformulaireid?: any, etat?: any, parent?: any, favorable?: any, dossier?: any, intervention?: any, visite?: any
  ,demande_date_debut?:string,demande_date_fin?:string ): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.formulaire:set',
      params: {
        type: form.ID,
        idDemande: demandeformulaireid ? demandeformulaireid : 0,
        options: {
          fields: form.fields,
          /*instruction: instruction.ID,
          demande: instruction.demande.ID,
          */
          etat: etat ? Number(etat) : 0,
          favorable: favorable ? Number(favorable) : 0
        }
      }
    })
    if (instruction) {
      rpcMethod.params.options.instruction = instruction.ID
      rpcMethod.params.options.demande = instruction.demande.ID
    }
    if (dossier)
      rpcMethod.params.options.dossier = dossier.ID
    if (intervention)
      rpcMethod.params.options.intervention = intervention  
    if (visite)
      rpcMethod.params.options.visite = visite
    if (demande_date_debut)
      rpcMethod.params.options.demande_date_debut = demande_date_debut
      
    if (demande_date_fin)
      rpcMethod.params.options.demande_date_fin = demande_date_fin
        
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  getList(_id: string, _options: any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.liste:get',
      params: {
        id: _id,
        options: _options
      }
    })
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  getListeSelection(_id: string, search: string, _tiersID: any = null, _options: any = []): Observable<any> {
	let no_data:boolean=false;
	if (_options.no_data!=undefined) {
		no_data=_options.no_data;
	}
	let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.selection:get',
      params: {
        id: _id,
        options:
        {
          filters: {
            search: {
              value: search
            },
            tiers: {
              value: _tiersID
            }
          },
		   nodata:	no_data,
           others:_options
        }

      }
    })
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  
  getListSelectionExport(_id: string,_options: any): Observable<any> {
	      let json={
	          jsonrpc : "2.0",
	          method:"webservice.selection:export",
	         
	  		params: {
	  		  id: _id,
	  		  options :_options
	          }
	      }
	  	/*if(_format)
	        json.params.options.format = _format;
	     */ 
	  	let rpcMethod = new JSONRpc(json)	
	  	
	      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  	}
  
  getListeSelectionOPtion(id: any, options: any = []): Observable<any> {
  		let rpcMethod = new JSONRpc({
  			jsonrpc: '2.0',
  			method: 'webservice.selection:get',
  			params: {
  				id: id,
  				options: options,
  			},
  		})
  		return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  

  getListeTierSelection(search: string): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.tiers:list',
      params: {
        'types': ['MAM'],
        options:
        {
          search: search
        }
      }
    })
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  getTierByID(id: string): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: '2.0',
      method: 'webservice.tiers:searchbyid',
      params: {
        id: id
      }
    })
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  getVilles(ville: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.adresse:villes',
        params: {
          ville: ville.toUpperCase()
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  getCodePostal(zip: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.adresse:codepostal',
        params: {
          zip: zip
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  getVillesByCP(zip: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.adresse:villebycp',
        params: {
          zip: zip
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  getRues(rue: string, villeid: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.adresse:rues',
        params: {
          libelle: rue.toUpperCase(),
          villeid: villeid
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  getRueByVille(villeid: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.adresse:ruebyville',
        params: {
          villeid: String(villeid)
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  getZone(villeid: string, numrue: string, rueid: string): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.adresse:zones',
        params: {
          villeid: villeid,
          options: {
            'numero': numrue,
            'rueid': rueid
          }
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  printFormulaire(id: any, nonull?: boolean, wide?: boolean): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.impression:print',
        params: {
          id: id,
          options: {
          }
        }
      }
    )
    if (nonull)
      rpcMethod.params.options.nonull = nonull
    if (wide)
      rpcMethod.params.options.wide = wide

    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }

  getRelationByDossier(id: any, typeRelation: any): Observable<any> {
    let rpcMethod = new JSONRpc(
      {
        jsonrpc: '2.0',
        method: 'webservice.dossier:relations',
        params: {
          id: id,
          options: {
            relations: typeRelation
          }
        }
      }
    )
    return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
  }
  
  getCheckFormulary(id: any, options: any = {}, method:string="doublon"): Observable<any> {
     let rpcMethod = new JSONRpc(
       {
         jsonrpc: '2.0',
         method: 'webservice.formulaire:check',
         params: {
           id: id,
		   method: method,
           options: options
         }
       }
     )
     return this.http.Post<JSONRpc>(environment.webservice, rpcMethod)
   }
   
   getGeoType(): Observable<any> {
       let rpcMethod = new JSONRpc(
         {
           jsonrpc : "2.0",
           method:"webservice.adresse:geotype",
           params: {
             
           }
         }
       )
       return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
     }
     
     getGeo(type:string): Observable<any> {
       let rpcMethod = new JSONRpc(
         {
           jsonrpc : "2.0",
           method:"webservice.adresse:geo",
           params: {
             type: type
           }
         }
       )
       return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
     }
}